export const complexMakesList = [
  'alfa-romeo',
  'land-rover',
  'mercedes-benz',
];

export const knownMakesList = [
  'acura',
  'audi',
  'bmw',
  'buick',
  'cadillac',
  'chevrolet',
  'chrysler',
  'dodge',
  'fiat',
  'ford',
  'gmc',
  'genesis',
  'honda',
  'hummer',
  'hyundai',
  'infiniti',
  'jaguar',
  'jeep',
  'kia',
  'lexus',
  'lincoln',
  'mazda',
  'mini',
  'mitsubishi',
  'nissan',
  'porsche',
  'ram',
  'scion',
  'smart',
  'subaru',
  'tesla',
  'toyota',
  'volkswagen',
  'volvo',
];